import React from 'react';
import { Link } from 'react-router-dom';
import { getCurrentCreators } from '../../utils/catalog';
export function CreatorMarquee() {
  const current = getCurrentCreators();
  const loop = [...current, ...current];
  return <section aria-label="Créateurs en vitrine" className="overflow-hidden border-y border-line bg-card py-5" data-id="element-302" data-mp="be2seq7gydae">
      <ul className="flex w-max animate-marquee items-center hover:[animation-play-state:paused]" data-id="element-303" data-mp="6g1d8gd5yy47">
        {loop.map((c, i) => <li key={`${c.id}-${i}`} className="flex items-center" aria-hidden={i >= current.length} data-id="element-304" data-mp="z2vuz5iljjdz" data-mpi={i}>
            <Link to={`/createurs/${c.id}`} tabIndex={i >= current.length ? -1 : undefined} className="whitespace-nowrap px-6 font-display text-3xl transition-colors duration-150 hover:text-clay md:text-4xl" data-id="element-305" data-mp="u3smtc7bkx1s">
              {c.name}
            </Link>
            <span className="h-1.5 w-1.5 rounded-full bg-clay" aria-hidden data-id="element-306" data-mp="39v6tdixdmged" />
          </li>)}
      </ul>
    </section>;
}